import { EProductOrderModeType } from "../Enum/EProductOrderModeType"
import { parseDateWithoutTimezoneShift } from "../Objects/Generics/Helps"

export const toReservationModeLabel = (mode?: EProductOrderModeType) => {
  if (mode === EProductOrderModeType.ReservationOnly) return "Somente reserva"
  if (mode === EProductOrderModeType.ImmediateAndReservation) return "Pedido e reserva"
  return "Pedido imediato"
}

export const formatReservationDays = (days?: number[]) => {
  if (!days || days.length === 0) return "-"

  const labels = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
  return days
    .filter((day) => day >= 0 && day <= 6)
    .sort((a, b) => a - b)
    .map((day) => labels[day])
    .join(", ")
}

export const formatReservationTimes = (times?: string[]) => (times && times.length > 0 ? times.join(", ") : "-")

export const normalizeReservationDateForInput = (value?: string | null): string => {
  if (!value) {
    return ""
  }

  const text = value.trim()

  if (!text) {
    return ""
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return text
  }

  return parseDateWithoutTimezoneShift(text).toInputDate()
}

export const normalizeReservationTimeForInput = (value?: string | null): string => {
  if (!value) {
    return ""
  }

  return value.toShortTime()
}
